import { useEffect } from "react";
import { Switch, Route, useLocation } from "wouter";
import { useQuery } from "@tanstack/react-query";
import { AdvisorNav } from "@/components/advisor/AdvisorNav";
import { ChangePasswordDialog } from "@/components/ChangePasswordDialog";
import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import AdvisorDashboardPage from "@/pages/advisor/AdvisorDashboard";
import AdvisorClientView from "@/pages/advisor/AdvisorClientView";
import AdvisorSettings from "@/pages/advisor/AdvisorSettings";
import NotFound from "@/pages/not-found";
import { Footer } from "@/components/Footer";

function AdvisorRootRedirect() {
  const [, setLocation] = useLocation();
  useEffect(() => { setLocation("/dashboard"); }, []);
  return null;
}

interface AdvisorProfile {
  fullName: string;
  companyName: string | null;
}

export function AdvisorDashboard() {
  const { user } = useAuth();
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  const { data: profile } = useQuery<AdvisorProfile>({ queryKey: ["/api/advisor/profile"] });

  // Force password change if required
  useEffect(() => {
    if (user?.mustChangePassword) {
      setChangePasswordOpen(true);
    }
  }, [user?.mustChangePassword]);

  return (
    <div className="flex flex-col min-h-screen">
      <AdvisorNav
        advisorName={profile?.fullName ?? user?.fullName}
        companyName={profile?.companyName ?? undefined}
        onChangePassword={() => setChangePasswordOpen(true)}
      />
      <main className="flex-1 bg-background">
        <Switch>
          <Route path="/dashboard" component={AdvisorDashboardPage} />
          <Route path="/client/:clientId">
            {(params) => <AdvisorClientView clientId={params.clientId} />}
          </Route>
          <Route path="/settings" component={AdvisorSettings} />
          <Route path="/advisor" component={AdvisorRootRedirect} />
          <Route component={NotFound} />
        </Switch>
      </main>
      <Footer />
      <ChangePasswordDialog
        open={changePasswordOpen}
        onOpenChange={setChangePasswordOpen}
        mustChange={user?.mustChangePassword}
      />
    </div>
  );
}
